import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';

import { motion, SVGMotionProps } from 'framer-motion';

import styles from './AccordionItem.scss';

type Props = {
  title: string;
  content: string;
};

const MinusIcon = ({ ...props }: SVGMotionProps<SVGSVGElement>) => (
  <motion.svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 -13 26 26"
    fill="none"
    {...props}
  >
    <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M1 1h24" />
  </motion.svg>
);

const AccordionItem = (props: Props) => {
  const { title, content }: Props = props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.accordionItem}>
      <div className={styles.itemHeader} onClick={() => setIsOpen(!isOpen)}>
        <h3 className={styles.headerTitle}>{title}</h3>
        <div className={styles.plusIcon}>
          <MinusIcon className={styles.icon} />
          <MinusIcon
            className={styles.icon}
            initial={{
              position: 'absolute',
              top: 1,
              left: -1,
              rotate: -90,
            }}
            animate={
              isOpen
                ? { top: 0, left: 0, rotate: 0, transition: { duration: 0.3 } }
                : { top: 1, left: -1, rotate: -90, transition: { duration: 0.3 } }
            }
          />
        </div>
      </div>
      <AnimateHeight duration={300} height={isOpen ? 'auto' : 0}>
        <div className={styles.itemContent} dangerouslySetInnerHTML={{ __html: content }} />
      </AnimateHeight>
    </div>
  );
};

export default AccordionItem;
